import { createContext, useContext } from "react";

export type LoadedCodeOfConduct = {
    file: { name: string; blobUrl: string; pdf: boolean; sha256: string; sizeBytes: number } | null;
};

export type CodeOfConductSource = {
    supplierName: string;
    customerName: string;
    key?: string;
    digitalSigning: boolean;
    signingAs?: string;
    signerName?: string;
    load: () => Promise<LoadedCodeOfConduct>;
};

export const CodeOfConductContext = createContext<CodeOfConductSource>({
    supplierName: "",
    customerName: "",
    digitalSigning: false,
    load: async () => ({ file: null }),
});

export const useCodeOfConductSource = () => useContext(CodeOfConductContext);
